import {IOrganizationAdvertiserLogin} from "../../../organizations/interfaces/IOrganizationAdvertiserLogin";
import {Grid, Divider, FormChips} from "@leap4/frontend";
import React from "react";
import {IUser} from "../edit/EditUser";

export interface IPublisherLoginsProps {
    pickedOrganizations: Array<IOrganizationAdvertiserLogin>,
    allOrganizations: Array<IOrganizationAdvertiserLogin>,
    user: IUser,
    setUser: (user: IUser) => void;
    //currentPublisherLogin: IPublisherLogins
}

export const UserOrganizationContainer = (props: IPublisherLoginsProps) => {

    const {pickedOrganizations, allOrganizations, user, setUser} = props
    const handleChange = (pickedOrg) => {
        setUser({
            _id: user._id,
            name: user.name,
            email: user.email,
            metadataMulti: pickedOrg,
        })
        return;
    };

    return (
        <>
            <Grid margin={"30px"}>
                <h1>Organizations</h1>
                <Divider/>
            </Grid>
            <Grid item xs={8}>

                <FormChips optionsList={allOrganizations}
                           onUpdateItems={handleChange}
                           inputName={"Organizations"}
                           enableCreate={false}
                           chips={pickedOrganizations.map(o => o._id)}
                           pureCreate={false}
                           textFieldProps={{size: "small", style: {width: "100%"}}}
                           stackProps={{style: {width: "100%"}}}
                           labelKey={"name"}
                           valueKey={"_id"}
                           disableCloseOnSelect={false}
                />
            </Grid>
        </>
    )
}



